import './zod-config.ts';
import '@itc/ui/tokens.css';
import { MODULES_KEY } from '@itc/sdk';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { modules } from './modules.ts';
import { createAppRouter } from './router.ts';

const pinia = createPinia();
const router = createAppRouter(pinia);
const app = createApp(App).use(pinia).use(router);
app.provide(MODULES_KEY, modules);

await router.isReady();
app.mount('#app');
